import {
  ApiErrorCodeMessages,
  ApiErrorCodeTypes,
  AuddlySignUpFormStep,
} from 'types/enums';
import { UseFormSetError } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { addAlertAction } from 'app/store/Alerts/slice';
import { routes } from 'app/routing/routesConfig';
import { apiErrorHandler } from 'app/utils/utils';
import { useAppDispatch } from 'app/store';
import { AxiosError } from 'axios';
import { AuddlySignUpFormFields } from 'app/components/AuddlySignUp/AuddlySignUpForm/AuddlySignUpForm';

interface UseAuddlySignUpErrorProps {
  afterSubmit: () => void;
  setCodeErrorMessage: (state: string) => void;
  setFormStep: (state: AuddlySignUpFormStep) => void;
  setError: UseFormSetError<AuddlySignUpFormFields>;
}

export const useAuddlySignUpError = ({
  setError,
  afterSubmit,
  setCodeErrorMessage,
  setFormStep,
}: UseAuddlySignUpErrorProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { search } = useLocation();

  const handleError = (e: AxiosError<any>) => {
    const response = e?.response?.data?.error;
    if (response?.errorCode === ApiErrorCodeTypes.EXPIRED_CODE) {
      dispatch(
        addAlertAction({
          message: 'We have sent you a new verification code, check your inbox',
          autoHideDuration: null,
        })
      );
      setCodeErrorMessage(
        'Code expired, a new one has been sent to your email'
      );
      navigate({ pathname: routes.auddlySignUpPassword.path, search });
    } else if (response?.errorCode === ApiErrorCodeTypes.INVALID_CODE) {
      dispatch(addAlertAction({ message: ApiErrorCodeMessages.INVALID_CODE }));
      setCodeErrorMessage(ApiErrorCodeMessages.INVALID_CODE);
      navigate({ pathname: routes.auddlySignUpPassword.path, search });
    } else if (response?.statusCode === 409) {
      dispatch(
        addAlertAction({
          message: 'Request could not be processed. Please sign-in',
        })
      );
      afterSubmit();
    } else if (
      response?.errorCode === ApiErrorCodeTypes.COGNITO_USER_NOT_FOUND
    ) {
      dispatch(
        addAlertAction({
          message: ApiErrorCodeMessages.COGNITO_USER_NOT_FOUND,
        })
      );
    } else if (response?.errorCode === ApiErrorCodeTypes.PASSWORD_TOO_WEAK) {
      setError('password', {
        message: 'Password too weak',
      });
      setFormStep(AuddlySignUpFormStep.PASSWORD_CREATION);
    } else {
      dispatch(addAlertAction({ message: apiErrorHandler(e.response) }));
    }
  };

  return { handleError };
};
